// Step 2 – Structure Analysis (AIAG/VDA 2019) data contracts & enum helpers
// These interfaces mirror the backend DTOs described in the specification.

export enum OperationTypeEnum {
  Undefined = 0,
  Process = 1, // Operation
  Test = 2,
  Inventory = 3,
  Transport = 4,
}

export enum Cause6MEnum {
  Man = 0,
  Machine = 1,
  Method = 2,
  Material = 3,
  Measurement = 4,
  Environment = 5,
}

export enum WorkElementTypeEnum {
  Undefined = 0,
  ValueAdded = 1,
  NonValueAdded = 2,
  RequiredNonValueAdded = 3,
}

export interface WorkElementDto {
  id: string;
  elementDescription: string;
  cause6m: Cause6MEnum;
  elementType: WorkElementTypeEnum;
}

export interface ProcessStepDto {
  id: string;
  operationId: string;
  type: OperationTypeEnum;
  rank: number;
  elements: WorkElementDto[];
  /** Dados da operação resolvidos pelo backend (ProcessStepResponse). */
  operationName?: string;
  operationRank?: number | null;
  operationCode?: string;
  operationDescription?: string;
}

export interface ProcessItemDto {
  id: string;
  name: string;
  steps: ProcessStepDto[];
}

/**
 * Contexto produtivo do FMEA que acompanha a árvore. Os campos são rótulos de exibição,
 * exceto sublineId — é com ele que o Step 2 carrega o catálogo de operações.
 */
export interface StructureAnalysisMetadataDto {
  processItem?: string;
  productionUnit?: string;
  area?: string;
  line?: string;
  subline?: string;
  sublineId?: string | null;
  family?: string;
  fmeaIdentifier?: string;
  fmeaType?: string;
  fmeaCategory?: string;
  product?: string;
  createdAt?: string | null;
  version?: string;
}

export interface StructureAnalysisTreeDto {
  analysisId: string;
  items: ProcessItemDto[];
  completed?: boolean;
  completedAt?: string;
  completedBy?: string;
  metadata?: StructureAnalysisMetadataDto;
}

// ---- Label maps ----
export const OperationTypeLabels: Record<OperationTypeEnum, string> = {
  [OperationTypeEnum.Undefined]: 'Undefined',
  [OperationTypeEnum.Process]: 'Process',
  [OperationTypeEnum.Test]: 'Test',
  [OperationTypeEnum.Inventory]: 'Inventory',
  [OperationTypeEnum.Transport]: 'Transport',
};

export const Cause6MLabels: Record<Cause6MEnum, string> = {
  [Cause6MEnum.Man]: 'Man',
  [Cause6MEnum.Machine]: 'Machine',
  [Cause6MEnum.Method]: 'Method',
  [Cause6MEnum.Material]: 'Material',
  [Cause6MEnum.Measurement]: 'Measurement',
  [Cause6MEnum.Environment]: 'Environment',
};

export const WorkElementTypeLabels: Record<WorkElementTypeEnum, string> = {
  [WorkElementTypeEnum.Undefined]: 'Undefined',
  [WorkElementTypeEnum.ValueAdded]: 'Value Added',
  [WorkElementTypeEnum.NonValueAdded]: 'Non Value Added',
  [WorkElementTypeEnum.RequiredNonValueAdded]: 'Required Non Value Added',
};

// Utility helpers
export function getOperationTypeLabel(v?: number | null): string {
  if (v == null) return '';
  return OperationTypeLabels[v as OperationTypeEnum] ?? '';
}
export function getCause6MLabel(v?: number | null): string {
  if (v == null) return '';
  return Cause6MLabels[v as Cause6MEnum] ?? '';
}
export function getWorkElementTypeLabel(v?: number | null): string {
  if (v == null) return '';
  return WorkElementTypeLabels[v as WorkElementTypeEnum] ?? '';
}
